export type ApplicationId = "pitstop" | "public";
export function determineApplicationId(pathname: string): ApplicationId {
  // may need to add more in depth logic here at some point
  if (pathname.startsWith("/public")) {
    return "public";
  }
  return "pitstop";
}
